import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import { useTranslation } from "react-i18next";
import 'swiper/css';

const Logos = [
  '/assets/logos/logo1.png',
  '/assets/logos/logo2.png',
  '/assets/logos/logo7.png',
  '/assets/logos/logo4.png',
  '/assets/logos/logo5.png',
  '/assets/logos/logo6.png',
  '/assets/logos/logo3.png',
];

const TrustedBySection = () => {
  const { t, i18n } = useTranslation("home");
  return (
    <section className="relative bg-[#020617] pt-24 pb-24 overflow-hidden">
      
      {/* --- SECTION DIVIDER / BEAM --- */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-indigo-500/20 to-transparent z-20"></div>
      <div className="absolute -top-10 left-1/2 -translate-x-1/2 w-[600px] h-[100px] bg-indigo-600/10 blur-[60px] rounded-full pointer-events-none z-10"></div>

      {/* --- BACKGROUND AMBIENCE --- */}
      <div className="absolute inset-0 pointer-events-none">
        <div 
          className="absolute inset-0 opacity-[0.03]"
          style={{
            backgroundImage: `linear-gradient(#fff 1px, transparent 1px), linear-gradient(90deg, #fff 1px, transparent 1px)`,
            backgroundSize: '40px 40px',
            maskImage: 'linear-gradient(to bottom, black 40%, transparent 100%)' 
          }}
        />
        <div className="absolute top-0 left-0 right-0 h-24 bg-gradient-to-b from-[#020617] to-transparent"></div>
      </div>

      <div className="absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-[#020617] via-[#020617]/80 to-transparent z-20 pointer-events-none"></div>
      <div className="absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-[#020617] via-[#020617]/80 to-transparent z-20 pointer-events-none"></div>

      <div className="max-w-7xl mx-auto px-6 md:px-10 relative z-10">
        
        {/* Header - BOLDER & BRIGHTER */}
        <div className="text-center mb-16">
            {/* Changed: font-semibold -> font-extrabold, and brightened the gradient start color */}
            <span lang={i18n.resolvedLanguage} className="inline-block bg-gradient-to-b from-white via-slate-200 to-slate-500 bg-clip-text text-transparent text-sm md:text-base font-extrabold tracking-[0.2em] uppercase opacity-100 drop-shadow-sm">
                {t("trustedBy")}
            </span>
            <div className="h-0.5 w-12 bg-gradient-to-r from-transparent via-slate-700 to-transparent mx-auto mt-4 opacity-50"></div>
        </div>

        {/* Logo Slider */}
        <div className="w-full">
            <Swiper
                modules={[Autoplay]}
                slidesPerView={3}
                breakpoints={{
                    640: { slidesPerView: 4 },
                    768: { slidesPerView: 5 },
                    1024: { slidesPerView: 6 },
                }}
                spaceBetween={60}
                loop={true}
                speed={3000} 
                allowTouchMove={false} 
                autoplay={{
                    delay: 0,
                    disableOnInteraction: false,
                }}
                className="w-full flex items-center"
            >
                {Logos.map((logo, index) => (
                <SwiperSlide key={index} className="flex items-center justify-center">
                    <div className="group cursor-pointer transition-all duration-500 opacity-30 hover:opacity-100 grayscale hover:grayscale-0">
                        <img
                            src={logo}
                            alt={`Partner Logo ${index}`}
                            className="h-8 md:h-10 w-auto object-contain brightness-0 invert transition-all duration-300 group-hover:scale-110 group-hover:brightness-100 group-hover:invert-0"
                            width={120}
                            height={40}
                        />
                    </div>
                </SwiperSlide>
                ))}
            </Swiper>
        </div>

      </div>
    </section>
  );
};

export default TrustedBySection;